import styled from 'styled-components';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export const Title = styled(Typography)`
  color: #182825;
  font-weight: 600;
`;

export const Wrapper = styled.div`
  // @ts-ignore
  background-color: ${props => (props as any).theme.palette.darkGreen};
  padding: 20px 10px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    margin-right: 20px;
  }

  h6 {
    line-height: 1.2;
  }
`;

export const BackButton = styled(Button)`
  text-transform: none;
  color: #b2b2b2;
`;
